module.exports = "/_next/static/images/ca39b3b2823f3aeec1ccf3e4ece07415-hero-lg.jpg";